import { CancellationState } from "@/data/model/Enums";

import { trans } from "@/operator/localization/Trans";

export class CancellationStateBadge {
    public static renderTo($parent: JQuery, cancellationState: CancellationState) {
        $(this.render(cancellationState)).appendTo($parent);
    }

    public static render(cancellationState: CancellationState) {
        const state = CancellationState[cancellationState];
        return `<span class="cancellation-state-badge">${trans.enums.cancellationState[state]}</span>`;
    }
}
